import { render, staticRenderFns } from "./BookCentreSaleByRange.vue?vue&type=template&id=25046535&"
import script from "./BookCentreSaleByRange.vue?vue&type=script&lang=js&"
export * from "./BookCentreSaleByRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports